var _path, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVinitText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SunCatcherStudio",
    fill: "none",
    stroke: "#ffffff",
    d: "M 32.550491,148.48008 A -108.15144,-108.15144 0 0 1 140.70194,40.328644 -108.15144,-108.15144 0 0 1 248.85338,148.48008 -108.15144,-108.15144 0 0 1 140.70194,256.63153 -108.15144,-108.15144 0 0 1 32.550491,148.48008 Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    fill: "#000000",
    letterSpacing: 3,
    fontFamily: "sans-serif",
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("textPath", {
    xlinkHref: "#SunCatcherStudio",
    side: "left",
    startOffset: 5
  }, "Java\xA0Spring\xA0Boot\xA0Developer\xA0-\xA0Vinit\xA0Kelginmane\xA0-"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinitText);
export default __webpack_public_path__ + "static/media/vinit-text.eb180b77f6d6807c371f0004627124ad.svg";
export { ForwardRef as ReactComponent };